import VueAuth from '@websanova/vue-auth';
import authDriver from '@websanova/vue-auth/drivers/auth/devise.js';
import httpDriver from '@websanova/vue-auth/drivers/http/axios.1.x.js';
import routerDriver from '@websanova/vue-auth/drivers/router/vue-router.2.x.js';

import store from '@/store';

function getCurrentUser(store) {
  if (store.getters.currentUser) {
    return Promise.resolve(store.getters.currentUser);
  } else {
    return new Promise((resolve) => {
      /* const unsubscribe = */ store.subscribe((mutation) => {
        // The mutation happens after our async request for user data, so it's
        // safe to assume that `store.getters.currentUser` is ready now.
        if (mutation.type === 'setCurrentUserId') {
          // It's not strictly necessary to call unsubscribe but we do it anyway
          // to be nice. Something something memory leaks.
          // TODO: `unsubscribe` doesn't seem to work in some cases. It has been
          // observed to actually unsubscribe multiple subscriptions. Need to
          // investigate later if we want to re-enable it.
          // unsubscribe();

          resolve(store.getters.currentUser);
        }
      });
    });
  }
}

function requiresRole(transition, ...roles) {
  // TODO: Consider polyfilling `flat()`.
  return transition.matched
    .map((m) => m.meta?.auth)
    .flat()
    .some((role) => roles.includes(role));
}

function redirectVueAuth(transition, status, title) {
  store.dispatch('setHttpError', {
    status,
    title,
  });

  // HACK: For some reason `header-context-hook.js` doesn't trigger the
  // callback where `vm` is instantiated so we have to manually call this.
  store.dispatch('setHeaderContext', {
    componentName: 'HeaderNavDefault',
  });

  return {
    name: 'httpError',
    params: [transition.path],
  };
}

export default function (Vue) {
  const loginPath = '/auth/login';

  Vue.use(VueAuth, {
    auth: authDriver,
    http: httpDriver,
    router: routerDriver,
    registerData: {
      url: 'auth',
      redirect: loginPath,
    },
    loginData: {
      url: 'auth/sign_in',
    },
    fetchData: {
      url: 'auth/validate_token',
      success: (response) => {
        store.dispatch('setCurrentUserId', response.data.data.id);
      },
    },
    logoutData: {
      url: 'auth/sign_out',
      method: 'DELETE',
      redirect: loginPath,
    },
    // This is disabled because `devise_token_auth` has its own refresh mechanism.
    // See https://github.com/lynndylanhurley/devise_token_auth/issues/377#issuecomment-413157417
    refreshData: {
      enabled: false,
    },
    rolesKey: 'role',
    notFoundRedirect: {
      name: 'game',
    },
    authRedirect: {
      path: loginPath,
    },
    forbiddenRedirect: (transition) => {
      return redirectVueAuth(transition, '403', 'Forbidden');
    },
  });

  const $auth = Vue.prototype.$auth;

  // Adds `$auth.whenCurrentUserReady` which will wait for the `currentUser`
  // state to asynchronously resolve in the vuex store. This is neccessary
  // because the time when `$auth.user()` is ready is sooner than when
  // `currentUser` is ready.
  Object.defineProperty($auth, 'whenCurrentUserReady', {
    value: () => {
      return new Promise((resolve) => {
        $auth.load().then(() => {
          if ($auth.check()) {
            getCurrentUser(store).then((currentUser) => {
              // During logout, `getCurrentUser` will resolve with null. We want
              // to avoid resolving during those cases since
              // whenCurrentUserReady is designed to only resolve during login.
              if (currentUser) {
                return resolve(currentUser);
              }
            });
          } else {
            resolve();
          }
        });
      });
    },
  });
}
